<template>
  <div>
    <div class="d-flex align-items-center mb-3">
      <div>
        <h1 class="page-header mb-0">
          <i class="fas fa-user-lock"></i> Csoport lakat szekrények
        </h1>
      </div>
      <div class="ms-auto">
        <button
          v-if="user.role_id == 1"
          class="btn btn-success btn-rounded px-4 rounded-pill"
          v-b-modal.addBoxModal
        >
          <i class="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i> Új
          szekrény
        </button>
      </div>
    </div>
    <b-modal
      id="addBoxModal"
      cancel-variant="default"
      @cancel="closeAddModal()"
      @ok="addBox"
      ok-title="Létrehozás"
      cancel-title="Mégse"
      :ok-disabled="loading"
      @shown="$refs.add_box_modal_number_input.focus()"
    >
      <template slot="modal-header">
        <h4 class="modal-title">Új csoport lakat szekrény</h4>
        <a class="btn-close" @click="closeAddModal()"></a>
      </template>
      <form
        @submit.prevent="addBox()"
        ref="box_modal_form"
        v-if="loading == false"
      >
        <div class="form-group">
          <label class="form-label">Lakatszekrény szám:</label>
          <input
            ref="add_box_modal_number_input"
            class="form-control"
            :class="{ 'is-invalid': errors.name }"
            type="number"
            v-model="box.number"
            required
          />
          <div v-if="errors.number" class="invalid-feedback d-block">
            {{ errors.number[0] }}
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Megnevezés:</label>
          <input
            ref="add_box_modal_name_input"
            class="form-control"
            :class="{ 'is-invalid': errors.name }"
            type="text"
            v-model="box.name"
            required
          />
          <div v-if="errors.name" class="invalid-feedback d-block">
            {{ errors.name[0] }}
          </div>
        </div>
        <div class="form-group mt-2">
          <label class="form-label">Munkaterület:</label>
          <div class="input-group">
            <b-dropdown variant="primary">
              <template slot="button-content">
                <i class="py-0 fa fa-caret-down"></i>
              </template>
              <LocationDropdownRow
                v-for="(location, id) in locations"
                :key="id"
                :location="location"
                @location-selected="selectLocation"
              ></LocationDropdownRow>
            </b-dropdown>
            <input
              type="text"
              v-model="box.location_name"
              placeholder="Válassz"
              class="form-control"
              :class="{ 'is-invalid': errors.location_id }"
              disabled
            />
          </div>
          <div v-if="errors.location_id" class="invalid-feedback d-block">
            {{ errors.location_id[0] }}
          </div>
        </div>
        <button class="d-none"></button>
      </form>
      <Loading v-else title="Létrehozás"></Loading>
    </b-modal>
    <panel title="Szekrények">
      <Loading v-if="boxes === false" title="Szekrények betöltése"></Loading>
      <NoRecords
        v-if="boxes.length == 0"
        main_icon="fas fa-user-lock"
        value="false"
        title="Nincsenek csoportlakat szekrények"
        subtitle="hozzon létre újat"
      ></NoRecords>
      <vue-good-table
        v-if="boxes.length != 0 && boxes !== false"
        :columns="columns"
        :rows="boxes"
        :lineNumbers="true"
        :search-options="{ enabled: false, placeholder: 'Keresés...' }"
        :pagination-options="{
          enabled: true,
          position: 'bottom',
          firstLabel: 'Első Lap',
          lastLabel: 'Utolsó Lap',
          nextLabel: 'következő',
          prevLabel: 'előző',
          rowsPerPageLabel: 'Sor oldalanként',
          ofLabel: '/',
          allLabel: 'Összes',
          infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <router-link
              :to="'boxes/' + props.row.id + '/edit'"
              class="btn btn-primary mx-1"
              title="szerkesztés"
              ><i class="fa fa-pen"></i
            ></router-link>
            <button
              @click="deleteBox(props.row.id)"
              class="btn btn-danger mx-1"
              title="törlés"
            >
              <i class="fa fa-trash"></i>
            </button>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </panel>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import NoRecords from "../../components/NoRecords";
import Box from "../../apis/Box";
import Confirmation from "../../apis/Confirmation";
import Location from "../../apis/Location";
import LocationDropdownRow from "../../components/LocationDropdownRow";

export default {
  components: {
    Loading,
    NoRecords,
    LocationDropdownRow,
  },
  data() {
    return {
      columns: [
        {
          label: "Szám",
          field: "number",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a számok között",
          },
        },
        {
          label: "Megnevezés",
          field: "name",
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a nevek között",
          },
        },
        {
          label: "Munkaterület",
          field: this.locationField,
          filterOptions: {
            enabled: true,
            placeholder: "Keresés a munkaterületek között",
          },
        },
        {
          label: "Műveletek",
          field: "actions",
          width: "15%",
          sortable: false,
          thClass: "text-end",
          tdClass: "text-end",
          hidden: true,
        },
      ],
      boxes: false,
      box: { is_unit: 0 },
      errors: [],
      loading: false,
      locations: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    locationslinear() {
      return this.$store.state.locationslinear;
    },
  },
  watch: {
    user: {
      handler(val) {
        if (val && val.role_id == 1) {
          this.$set(this.columns[3], "hidden", false);
        } else {
          this.$set(this.columns[3], "hidden", true);
        }
      },
      deep: true,
    },
  },
  created() {
    Box.index().then((response) => {
      this.boxes = response.data;
    });
    Location.index().then((response) => {
      this.locations = response.data;
    });
  },
  mounted() {
    if (this.user.role_id == 1) {
      this.$set(this.columns[3], "hidden", false);
    }
  },
  methods: {
    locationField(rowObj) {
      if (rowObj.location_id) {
        return this.locationslinear[
          this.locationslinear
            .map((location) => location.id)
            .indexOf(rowObj.location_id)
        ].name;
      } else {
        return "nincs megadva munkaterület";
      }
    },
    selectLocation(location) {
      this.$set(this.box, "location_id", location.id);
      this.$set(this.box, "location_name", location.name);
    },
    closeAddModal() {
      this.box = { is_unit: 0 };
      this.errors = [];
      this.$bvModal.hide("addBoxModal");
    },
    addBox(bvModalEvt) {
      this.loading = true;
      if (bvModalEvt) {
        //ok gombra van csak event
        bvModalEvt.preventDefault();
      }
      Box.add(this.box)
        .then((response) => {
          this.boxes.unshift(response.data);
          this.errors = [];
          this.closeAddModal();
          this.$router.push({
            path: "/base-data/boxes/" + response.data.id + "/edit",
          });
        })
        .catch((error) => {
          if (error.response.data.errors) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteBox(id) {
      Confirmation.swalDelete().then((response) => {
        if (response.isConfirmed === true) {
          Box.delete(id)
            .then(() => {
              this.boxes.splice(this.boxes.map((box) => box.id).indexOf(id), 1);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
  },
};
</script>

<style></style>
